<div class="c-empty" [class.-no-border]="noBorder" [ngStyle]="{ 'height.px': height }" [ngClass]="customClass">
  <div class="c-empty__inner">
    <div class="c-empty__icon">
      <img [src]="'assets/new-img/icons/black/' + icon + '.svg'" alt="empty" />
    </div>
    <div class="c-empty__desc">{{ desc }}</div>
    <ng-container *ngIf="actions && actions.length">
      <div *ngFor="let action of actions" class="c-empty__action">
        <ng-container *ngTemplateOutlet="action"></ng-container>
      </div>
    </ng-container>
  </div>
</div>
